import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=bcdea59e&scoped=true&lang=pug&"
import script from "./EventDetail.vue?vue&type=script&lang=ts&"
export * from "./EventDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=bcdea59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdea59e",
  null
  
)

export default component.exports